import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

export const useMortgageCalc = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openFailure, setOpenFailure] = useState(false);

  const { data, isLoading, mutate } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/calculator/mortgage`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (res) => {
        // @ts-ignore
        if (res?.data?.eligible) {
          setOpenModal(true);
        } else setOpenFailure(true);
      },
    }
  );

  return {
    mutate,
    data,
    isLoading,
    openModal,
    setOpenModal,
    openFailure,
    setOpenFailure,
  };
};
